import { Button, Group, Progress, Stack, Text } from "@mantine/core"
import { QuickQueueStats } from "../../-components/DutyScheduling/duty-roster-spreadsheet"
import { useTranslation } from "react-i18next"

export function QuickQueueWidget({
  stats,
  onCancel,
}: {
  stats: QuickQueueStats
  onCancel: (() => void) | null
}) {
  const { t } = useTranslation("app_server")

  if (!stats.visible) {
    return null
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 8,
        right: 8,
        zIndex: 560,
        border: "1px solid var(--mantine-color-gray-4)",
        background:
          "light-dark(var(--mantine-color-white), var(--mantine-color-dark-7))",
        borderRadius: 6,
        padding: 8,
      }}
    >
      <Stack gap={6}>
        <Group gap={8} wrap="nowrap" justify="space-between">
          <Text size="xs">
            {stats.completed}/{stats.total} ({stats.percent}%)
          </Text>
          <Button
            size="compact-xs"
            color="red"
            variant="light"
            disabled={stats.cancelRequested || !onCancel}
            onClick={() => {
              onCancel?.()
            }}
          >
            {stats.cancelRequested ? t("QuickQueue_Canceling") : t("Cancel")}
          </Button>
        </Group>
        <Progress
          value={stats.percent}
          size="sm"
          radius="sm"
          color={stats.cancelRequested ? "orange" : "blue"}
        />
        <Text size="xs" c="dimmed">
          {stats.cancelRequested
            ? t("QuickQueue_CancelRequested")
            : stats.running
              ? t("QuickQueue_Running", { count: stats.pending })
              : t("QuickQueue_Pending", { count: stats.pending })}
        </Text>
      </Stack>
    </div>
  )
}
